import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SNACK_BAR_DURATION } from '@core/const';
import { ErrorMessageComponent } from '@shared/components';

@Injectable({
  providedIn: 'root',
})
export class ShowErrorService {
  private readonly snackBar = inject(MatSnackBar);

  show(status?: number, message?: string) {
    this.snackBar.openFromComponent(ErrorMessageComponent, {
      duration: SNACK_BAR_DURATION,
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: 'error-snackbar',
      data: {
        status,
        message,
      },
    });
  }
}
